import type { MutationHookOptions } from '@apollo/client'
import {
  PeopleChartDeleteTeamMemberDocument,
  PeopleChartDeleteTeamMemberMutation,
  PeopleChartDeleteTeamMemberMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  PeopleChartDeleteTeamMemberMutation,
  PeopleChartDeleteTeamMemberMutationVariables
>

export const useDeleteMember = (options?: Options) => {
  const [deleteMember, { loading }] = useMutation(PeopleChartDeleteTeamMemberDocument, {
    ...options,
    extractorFn: (data) => data.teamsMutations?.deleteTeamsMembership,
  })

  return {
    loading,
    deleteMember,
  }
}
